import React, { useState } from 'react';
import { Link } from 'react-router-dom';

/* ─────────────────────────────────────────────────────────────────────────────
   QUIZ · MODOS DE VENTA
   Test de conocimientos sobre los modos de venta VACWAYLockers.
   20 preguntas, puntuación sobre 10.
───────────────────────────────────────────────────────────────────────────── */

const C = {
  primary: '#0284c7',
  correct: '#16a34a',
  wrong:   '#dc2626',
};

const CSS = `
  .quiz-page { width: 100%; max-width: 860px; margin: 0 auto; padding: 32px 28px 64px; font-family: inherit; color: #1e293b; box-sizing: border-box; }
  .quiz-hero { border-radius: 14px; padding: 32px 32px; margin-bottom: 28px; color: #fff; position: relative; overflow: hidden;
    background: linear-gradient(135deg, #0c4a6e 0%, #0284c7 55%, #38bdf8 100%); }
  .quiz-hero-back { display: inline-flex; align-items: center; gap: 6px; color: rgba(255,255,255,0.85);
    font-size: 13px; font-weight: 600; text-decoration: none; margin-bottom: 14px; transition: color 0.15s; }
  .quiz-hero-back:hover { color: #fff; }
  .quiz-hero h1 { font-size: 26px; font-weight: 800; margin: 0 0 8px; line-height: 1.25; }
  .quiz-hero p { font-size: 14px; opacity: 0.9; line-height: 1.55; margin: 0; }
  .quiz-progress { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
  .quiz-progress-bar { flex: 1; height: 6px; background: #e2e8f0; border-radius: 3px; overflow: hidden; }
  .quiz-progress-fill { height: 100%; background: #0284c7; border-radius: 3px; transition: width 0.3s ease; }
  .quiz-progress-text { font-size: 12px; font-weight: 700; color: #64748b; white-space: nowrap; }
  .quiz-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 28px; margin-bottom: 16px; }
  .quiz-q-num { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; color: #0284c7; margin-bottom: 6px; }
  .quiz-q-text { font-size: 16px; font-weight: 700; color: #0f172a; line-height: 1.45; margin-bottom: 18px; }
  .quiz-options { display: flex; flex-direction: column; gap: 8px; }
  .quiz-option { display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-radius: 8px;
    border: 1.5px solid #e2e8f0; cursor: pointer; transition: all 0.15s; font-size: 14px; color: #1e293b; line-height: 1.45;
    background: #fff; }
  .quiz-option:hover { border-color: #93c5fd; background: #f0f9ff; }
  .quiz-option.selected { border-color: #0284c7; background: #eff6ff; }
  .quiz-option.correct { border-color: #16a34a; background: #f0fdf4; }
  .quiz-option.wrong { border-color: #dc2626; background: #fef2f2; }
  .quiz-option.disabled { pointer-events: none; opacity: 0.7; }
  .quiz-option.disabled.correct { opacity: 1; }
  .quiz-radio { width: 18px; height: 18px; border-radius: 50%; border: 2px solid #cbd5e1; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center; transition: all 0.15s; }
  .quiz-option.selected .quiz-radio { border-color: #0284c7; background: #0284c7; }
  .quiz-option.correct .quiz-radio { border-color: #16a34a; background: #16a34a; }
  .quiz-option.wrong .quiz-radio { border-color: #dc2626; background: #dc2626; }
  .quiz-radio-dot { width: 6px; height: 6px; border-radius: 50%; background: #fff; opacity: 0; transition: opacity 0.15s; }
  .quiz-option.selected .quiz-radio-dot,
  .quiz-option.correct .quiz-radio-dot,
  .quiz-option.wrong .quiz-radio-dot { opacity: 1; }
  .quiz-explain { margin-top: 14px; padding: 12px 16px; border-radius: 8px; font-size: 13px; line-height: 1.55; }
  .quiz-explain.right { background: #f0fdf4; border: 1px solid #86efac; color: #15803d; }
  .quiz-explain.wrong { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; }
  .quiz-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 28px; border-radius: 8px;
    font-size: 14px; font-weight: 700; border: none; cursor: pointer; transition: all 0.15s; }
  .quiz-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .quiz-btn-primary { background: #0284c7; color: #fff; }
  .quiz-btn-primary:hover:not(:disabled) { background: #0369a1; }
  .quiz-btn-outline { background: #fff; color: #0284c7; border: 1.5px solid #0284c7; }
  .quiz-btn-outline:hover { background: #f0f9ff; }
  .quiz-actions { display: flex; justify-content: center; gap: 12px; margin-top: 28px; flex-wrap: wrap; }
  .quiz-result { background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 36px 32px; text-align: center; }
  .quiz-result-score { font-size: 64px; font-weight: 900; line-height: 1; margin-bottom: 4px; }
  .quiz-result-max { font-size: 18px; color: #64748b; font-weight: 600; margin-bottom: 14px; }
  .quiz-result-label { font-size: 20px; font-weight: 800; margin-bottom: 8px; }
  .quiz-result-text { font-size: 14px; color: #475569; line-height: 1.55; max-width: 480px; margin: 0 auto 24px; }
  .quiz-result-bar { width: 100%; max-width: 400px; height: 10px; background: #e2e8f0; border-radius: 5px; margin: 0 auto 24px; overflow: hidden; }
  .quiz-result-bar-fill { height: 100%; border-radius: 5px; transition: width 0.6s ease; }
  .quiz-summary { display: flex; justify-content: center; gap: 8px; flex-wrap: wrap; margin-bottom: 24px; }
  .quiz-summary-dot { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
    font-size: 11px; font-weight: 800; color: #fff; }
  @media (max-width: 768px) {
    .quiz-page { padding: 20px 16px 48px !important; }
    .quiz-hero { padding: 22px 18px !important; }
    .quiz-hero h1 { font-size: 20px !important; }
    .quiz-card { padding: 20px 16px !important; }
    .quiz-q-text { font-size: 14.5px !important; }
    .quiz-result { padding: 24px 18px !important; }
    .quiz-result-score { font-size: 48px !important; }
  }
`;

const QUESTIONS = [
  {
    q: '¿Cuántas taquillas puede gestionar un solo ordenador Vacway?',
    options: ['50–80 taquillas', '100–120 taquillas', '150–200 taquillas', '250–300 taquillas'],
    correct: 1,
    explain: 'Cada pantalla VLK06 o sistema QR gestiona entre 100 y 120 taquillas y requiere 1 licencia de software independiente.',
  },
  {
    q: '¿Cuál es la "regla de oro" del sistema VACWAYLockers?',
    options: [
      '1 taquilla = 1 usuario',
      '1 ordenador = 1 modo de uso',
      '1 licencia = todos los modos',
      '1 pantalla = múltiples modos',
    ],
    correct: 1,
    explain: 'Cada pantalla VLK06 o sistema QR solo puede configurarse para un único modo. No se pueden mezclar modos en la misma pantalla.',
  },
  {
    q: '¿Qué modo de venta se debe recomendar en el 80% de los casos?',
    options: ['Modo por abertura', 'Modo por horas', 'Modo por día (24h)', 'Cualquiera, depende del cliente'],
    correct: 2,
    explain: 'El modo por día es la primera opción siempre: máxima satisfacción del usuario final, menos complicaciones técnicas y permite venta multicanal.',
  },
  {
    q: '¿Qué significa "Quick Access" en el contexto de VACWAYLockers?',
    options: [
      'Acceso rápido a la configuración del sistema',
      'El usuario abre la taquilla directamente con PIN en el teclado digital, sin volver a la pantalla',
      'Apertura automática con sensor de proximidad',
      'Reserva rápida desde la app móvil',
    ],
    correct: 1,
    explain: 'Quick Access permite al usuario abrir su taquilla directamente tecleando el PIN en el teclado de la propia taquilla, sin necesidad de ir a la pantalla VLK06.',
  },
  {
    q: '¿Qué función tiene el "Night Scan" en el modo por día?',
    options: [
      'Escanear códigos QR por la noche',
      'Realizar un inventario automático de taquillas vacías',
      'Resetear el sistema por la noche y liberar todas las taquillas',
      'Activar el modo de bajo consumo energético',
    ],
    correct: 2,
    explain: 'El Night Scan resetea el sistema automáticamente por la noche (hora configurable) y libera todas las taquillas para el día siguiente.',
  },
  {
    q: '¿Qué canales de venta tiene disponibles el modo por horas?',
    options: [
      'Pantalla táctil + QR + Online',
      'Solo QR online',
      'Solo pantalla táctil VLK06',
      'Pantalla táctil + venta anticipada',
    ],
    correct: 2,
    explain: 'El modo por horas NO permite QR Code ni venta online. Todo el proceso debe hacerse exclusivamente desde la pantalla táctil VLK06.',
  },
  {
    q: '¿Cuántas aperturas tiene el cliente en el modo por abertura?',
    options: [
      '1 apertura',
      '2 aperturas (+ tiempo de cortesía)',
      'Ilimitadas',
      '3 aperturas',
    ],
    correct: 1,
    explain: 'El modo por abertura permite 2 aperturas: una para dejar pertenencias y otra para recogerlas. Incluye un tiempo de cortesía configurable entre ambas.',
  },
  {
    q: '¿Qué ocurre con el teclado digital de la taquilla en el modo por horas?',
    options: [
      'Funciona con código PIN igual que en otros modos',
      'Se activa solo tras pagar en pantalla',
      'Queda completamente inactivo, desperdiciando hardware',
      'Se usa para introducir la franja horaria',
    ],
    correct: 2,
    explain: 'En el modo por horas, el teclado digital de cada taquilla queda inactivo. La puerta solo se abre desde la pantalla táctil, lo que desperdicia hardware y genera dependencia del módulo VLK06.',
  },
  {
    q: 'Si un cliente necesita alta rotación de taquillas pero quieres mantener buena UX, ¿qué modo recomendarías primero?',
    options: [
      'Modo por horas (máxima rotación)',
      'Modo por día (siempre la mejor opción)',
      'Modo por abertura (equilibrio rotación + UX)',
      'Combinar modos en la misma pantalla',
    ],
    correct: 2,
    explain: 'El modo por abertura permite mayor rotación que el modo por día, manteniendo Quick Access, QR y buena UX. Es la segunda opción recomendada y preferible al modo por horas.',
  },
  {
    q: '¿Cuáles son los tres tipos de licencia de software VACWAYLockers?',
    options: [
      'Free, Standard, Enterprise',
      'Básica, Pro, PDA/PC',
      'Lite, Plus, Premium',
      'Starter, Business, Corporate',
    ],
    correct: 1,
    explain: 'Las licencias son: BÁSICA (gestión estándar), PRO (QR, venta anticipada, online e integración ERP) y PDA/PC (venta desde tablets o integración web directa).',
  },
  {
    q: '¿Puede un cliente del modo por día reasignar su taquilla a otra persona antes de que acabe el día?',
    options: [
      'Sí, desde la pantalla táctil en cualquier momento',
      'Sí, pero solo con autorización del administrador',
      'No, la taquilla queda bloqueada hasta el Night Scan nocturno',
      'Sí, si introduce el PIN original',
    ],
    correct: 2,
    explain: 'Una vez asignada, la taquilla NO puede reasignarse a otro cliente hasta el reseteo nocturno (Night Scan). Si el cliente se va antes de tiempo, queda bloqueada.',
  },
  {
    q: '¿Qué ocurre si un usuario del modo por día deja la taquilla vacía voluntariamente antes del cierre?',
    options: [
      'Se libera automáticamente para otro usuario',
      'Se pone en modo de espera para reasignación manual',
      'Permanece bloqueada hasta el siguiente Night Scan',
      'Se cobra una tarifa extra por abandono anticipado',
    ],
    correct: 2,
    explain: 'Incluso si el usuario deja la taquilla libre voluntariamente, NO se pone a la venta hasta el siguiente Night Scan. Punto clave a explicar al cliente B2B.',
  },
  {
    q: '¿Qué tipo de licencia necesita un cliente que quiere integrar la venta con su propia web?',
    options: [
      'Licencia Básica',
      'Licencia Pro',
      'Licencia PDA/PC',
      'No necesita licencia adicional',
    ],
    correct: 2,
    explain: 'La licencia PDA/PC permite venta desde tablets, PC de recepción o integración directa con la web del cliente.',
  },
  {
    q: '¿Cuál es el tiempo de cortesía en el modo por abertura?',
    options: [
      'No existe tiempo de cortesía',
      '5 minutos fijos',
      'Es configurable por el cliente B2B (5, 10 o 15 minutos)',
      '30 minutos por defecto',
    ],
    correct: 2,
    explain: 'El tiempo de cortesía entre aperturas es configurable (5, 10 o 15 minutos), lo que mejora la UX al permitir al usuario re-entrar si olvidó algo.',
  },
  {
    q: '¿Qué pasa en el modo por horas si el cliente excede el tiempo de su slot?',
    options: [
      'Se cobra la siguiente franja automáticamente',
      'Se aplica una penalización automática (con tiempo de cortesía configurable)',
      'La taquilla se abre sola y se liberan las pertenencias',
      'No pasa nada, el tiempo es orientativo',
    ],
    correct: 1,
    explain: 'Se aplica una penalización automática por exceso de tiempo, aunque existe un tiempo de cortesía configurable antes de que se aplique.',
  },
  {
    q: '¿Qué modo de uso permite venta anticipada online?',
    options: [
      'Solo modo por día',
      'Modo por día y modo por abertura',
      'Los tres modos',
      'Ninguno, requiere compra presencial',
    ],
    correct: 1,
    explain: 'Tanto el modo por día como el modo por abertura son compatibles con QR Code y venta anticipada online. El modo por horas NO lo permite.',
  },
  {
    q: '¿Pueden convivir diferentes modos de uso en la misma instalación?',
    options: [
      'No, toda la instalación usa un solo modo',
      'Sí, cada ordenador/pantalla puede tener su propio modo',
      'Solo si tienen la misma licencia',
      'Solo si comparten la misma red WiFi',
    ],
    correct: 1,
    explain: 'Cada ordenador (pantalla VLK06 o sistema QR) se configura con un modo independiente. En instalaciones grandes se pueden combinar diferentes modos entre distintos ordenadores.',
  },
  {
    q: '¿Cómo se libera una taquilla en el modo por abertura?',
    options: [
      'Automáticamente tras la segunda apertura y expirar el tiempo de cortesía',
      'El usuario debe pulsar un botón de liberación en pantalla',
      'Solo mediante Night Scan nocturno',
      'El administrador la libera manualmente',
    ],
    correct: 0,
    explain: 'Tras la segunda apertura (recoger pertenencias) y expirar el tiempo de cortesía, la taquilla se libera automáticamente para el siguiente cliente.',
  },
  {
    q: '¿Cuál es el principal argumento para desaconsejar el modo por horas a un cliente?',
    options: [
      'Es más caro de licenciar',
      'Pierde Quick Access y no permite QR/venta online, empeorando la UX y limitando canales de venta',
      'No permite más de 50 taquillas por ordenador',
      'Requiere conexión a internet permanente',
    ],
    correct: 1,
    explain: 'El modo por horas desactiva Quick Access, no permite QR ni venta online, y desperdicia el teclado digital. Se recomienda reconducir al modo por abertura cuando el cliente pide alta rotación.',
  },
  {
    q: '¿Qué clientes de referencia utilizan el modo por abertura?',
    options: [
      'Amazon y Google',
      'Port Aventura, Aquarium Barcelona y Caldea',
      'RENFE y Aena',
      'Decathlon y El Corte Inglés',
    ],
    correct: 1,
    explain: 'Port Aventura, Aquarium Barcelona y Caldea son casos de referencia reales del modo por abertura, útiles como argumento comercial.',
  },
];

const getResult = (score) => {
  if (score >= 9) return { color: '#16a34a', label: '¡Excelente!', text: 'Dominas los modos de venta a la perfección. Estás preparado para asesorar a cualquier cliente B2B con total confianza.' };
  if (score >= 7) return { color: '#0284c7', label: '¡Muy bien!', text: 'Tienes un buen dominio de los conceptos clave. Repasa los puntos que fallaste para perfeccionar tu conocimiento.' };
  if (score >= 5) return { color: '#d97706', label: 'Aprobado', text: 'Conoces los fundamentos, pero hay aspectos importantes que debes reforzar. Te recomendamos repasar la guía de modos de venta.' };
  return { color: '#dc2626', label: 'Necesitas repasar', text: 'Es importante que revises la guía de modos de venta completa antes de asesorar a clientes. ¡Ánimo, seguro que la próxima vez lo clavas!' };
};

const SalesModesQuizView = () => {
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const answered = Object.keys(answers).length;
  const allAnswered = answered === QUESTIONS.length;

  const handleSelect = (qi, oi) => {
    if (submitted) return;
    setAnswers(prev => ({ ...prev, [qi]: oi }));
  };

  const handleSubmit = () => {
    if (!allAnswered) return;
    setSubmitted(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleRetry = () => {
    setAnswers({});
    setSubmitted(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const score = submitted
    ? Math.round(QUESTIONS.reduce((acc, q, i) => acc + (answers[i] === q.correct ? 1 : 0), 0) * 10 / QUESTIONS.length * 10) / 10
    : 0;

  const result = getResult(score);

  return (
    <div className="quiz-page">
      <style>{CSS}</style>

      {/* HERO */}
      <div className="quiz-hero">
        <div style={{ position: 'absolute', right: -30, top: -30, width: 180, height: 180, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />
        <Link to="/sales-modes" className="quiz-hero-back">← Volver a la guía</Link>
        <h1>📝 Quiz · Modos de venta</h1>
        <p>Pon a prueba tus conocimientos sobre los modos de funcionamiento de las taquillas VACWAYLockers. 20 preguntas, puntuación sobre 10.</p>
      </div>

      {/* PROGRESS */}
      {!submitted && (
        <div className="quiz-progress">
          <div className="quiz-progress-bar">
            <div className="quiz-progress-fill" style={{ width: `${(answered / QUESTIONS.length) * 100}%` }} />
          </div>
          <span className="quiz-progress-text">{answered} / {QUESTIONS.length}</span>
        </div>
      )}

      {/* RESULT */}
      {submitted && (
        <div className="quiz-result" style={{ marginBottom: 28 }}>
          <div className="quiz-result-score" style={{ color: result.color }}>{score}</div>
          <div className="quiz-result-max">de 10 puntos</div>
          <div className="quiz-result-bar">
            <div className="quiz-result-bar-fill" style={{ width: `${score * 10}%`, background: result.color }} />
          </div>
          <div className="quiz-result-label" style={{ color: result.color }}>{result.label}</div>
          <div className="quiz-result-text">{result.text}</div>
          <div className="quiz-summary">
            {QUESTIONS.map((q, i) => (
              <div
                key={i}
                className="quiz-summary-dot"
                style={{ background: answers[i] === q.correct ? '#16a34a' : '#dc2626' }}
              >
                {i + 1}
              </div>
            ))}
          </div>
          <div className="quiz-actions">
            <button className="quiz-btn quiz-btn-primary" onClick={handleRetry}>Repetir quiz</button>
            <Link to="/sales-modes" className="quiz-btn quiz-btn-outline" style={{ textDecoration: 'none' }}>Volver a la guía</Link>
          </div>
        </div>
      )}

      {/* QUESTIONS */}
      {QUESTIONS.map((q, qi) => {
        const userAnswer = answers[qi];
        const isAnswered = userAnswer !== undefined;
        const isCorrect = submitted && userAnswer === q.correct;
        const isWrong = submitted && isAnswered && userAnswer !== q.correct;

        return (
          <div key={qi} className="quiz-card">
            <div className="quiz-q-num">Pregunta {qi + 1}</div>
            <div className="quiz-q-text">{q.q}</div>
            <div className="quiz-options">
              {q.options.map((opt, oi) => {
                let cls = 'quiz-option';
                if (submitted) {
                  cls += ' disabled';
                  if (oi === q.correct) cls += ' correct';
                  else if (oi === userAnswer && oi !== q.correct) cls += ' wrong';
                } else if (oi === userAnswer) {
                  cls += ' selected';
                }
                return (
                  <div key={oi} className={cls} onClick={() => handleSelect(qi, oi)}>
                    <div className="quiz-radio"><div className="quiz-radio-dot" /></div>
                    <span>{opt}</span>
                  </div>
                );
              })}
            </div>
            {submitted && (
              <div className={`quiz-explain ${isCorrect ? 'right' : 'wrong'}`}>
                {isCorrect ? '✓ ¡Correcto! ' : `✗ Incorrecto. `}
                {q.explain}
              </div>
            )}
          </div>
        );
      })}

      {/* VALIDATE */}
      {!submitted && (
        <div className="quiz-actions">
          <button
            className="quiz-btn quiz-btn-primary"
            disabled={!allAnswered}
            onClick={handleSubmit}
          >
            {allAnswered ? '✓ Validar respuestas' : `Responde las ${QUESTIONS.length} preguntas`}
          </button>
        </div>
      )}
    </div>
  );
};

export default SalesModesQuizView;
